import { useState } from "react";
import { BonusesSection, VolumesSection } from "../components/aquagym/CurriculumSections";
import { Footer } from "../components/aquagym/Footer";
import { HeroSection } from "../components/aquagym/HeroSection";
import { OfferSection } from "../components/aquagym/OfferSection";
import { ProblemsSection, ProductPresentationSection, SystemOverviewSection } from "../components/aquagym/SystemSections";
import { ComparisonSection, FaqSection, GuaranteeSection, TestimonialsSection } from "../components/aquagym/TrustSections";
export function AquagymLanding() {
  const [openAccordionItem, setOpenAccordionItem] = useState("");
  return <main className="min-h-screen w-full overflow-x-hidden bg-white text-[#1E293B]" data-id="element-236" data-mp="2946l1c95r6vs">
      <HeroSection data-id="element-237" data-mp="246eq09d7v4nd" />
      <ProblemsSection data-id="element-238" data-mp="2490xk903xk5l" />
      <ProductPresentationSection data-id="element-239" data-mp="xqm9rp01ob5t" />
      <SystemOverviewSection data-id="element-240" data-mp="xrnkfsd5evn0" />
      <VolumesSection openItem={openAccordionItem} onOpenChange={setOpenAccordionItem} data-id="element-241" data-mp="xorlc0pke0wz" />
      <BonusesSection openItem={openAccordionItem} onOpenChange={setOpenAccordionItem} data-id="element-242" data-mp="sqgbhpz9rqer" />
      <OfferSection data-id="element-243" data-mp="361mffg3lry2q" />
      <TestimonialsSection data-id="element-244" data-mp="35z06pd4z7cix" />
      <GuaranteeSection data-id="element-245" data-mp="3azw9fndlcsmr" />
      <FaqSection openItem={openAccordionItem} onOpenChange={setOpenAccordionItem} data-id="element-246" data-mp="3az4pj9tcwjcb" />
      <ComparisonSection data-id="element-247" data-mp="2w3f35ak9e472" />
      <OfferSection repeated data-id="element-248" data-mp="2w23xf5796mdb" />
      <Footer data-id="element-249" data-mp="2w4zy31ahjp5g" />
    </main>;
}